import * as z from 'zod'
import {buildPageSchemaForTemplate} from '@github-ui/swp-core/schemas/contentful/contentTypes/containerPage'
import {TemplateFlexSuiteOverviewSchema} from './templateFlexSuiteOverview'

export const FlexSuiteOverviewPageSchema = buildPageSchemaForTemplate(TemplateFlexSuiteOverviewSchema)
export type FlexSuiteOverviewPage = z.infer<typeof FlexSuiteOverviewPageSchema>
